// Event, Dialog
import {
    mapState
} from "vuex";
import EventBus from "@/event/EventBus";

// Extend
import baseRentalService from '@/scripts/rentalService/baseRentalService';

// Constant
import { SERVICE_TYPE } from '@/constant/rental';
const _ = require('lodash');
const io = require("socket.io-client");
const clientappSocketUrl = process.env.VUE_APP_SOCKET_CLIENT_APP_URL;
export default {

    extends: baseRentalService,

    data() {
        return {
            socket: null,
        };
    },


    computed: {
        ...mapState({
            user: state => state.auth.user,
        }),
    },

    created() {
        EventBus.$on("processingEventRental", this.processingEvent);
        this.machineListRequest.serviceType = SERVICE_TYPE.GPUHUB;
        this.machineListView();
        this.timer = setInterval(this.autoRefresh, 10000)
    },

    mounted() {
        this.socket = io(clientappSocketUrl, {
            forceNew: true
        });

        // this.throt_fun1 = _.throttle(function (data) {
        //     console.log("CHANGED_PROGRESS_CLIENT:", data)
        // }, 1000);
        // this.throt_fun2 = _.throttle(function (data) {
        //     console.log("CHANGED_BOOT_STEP_CLIENT:", data)
        // }, 1000);
        // this.throt_fun3 = _.throttle(function (data) {
        //     console.log("CHANGED_SHUTDOWN_STEP_CLIENT:", data)
        // }, 1000);

        this.socket.on("CHANGED_PROGRESS_CLIENT", (data) => {
            console.log("CHANGED_PROGRESS_CLIENT:", data)
        });
        this.socket.on("CHANGED_BOOT_STEP_CLIENT", (data) => {
            console.log("CHANGED_BOOT_STEP_CLIENT:", data)
        });
        this.socket.on("CHANGED_SHUTDOWN_STEP_CLIENT", (data) => {
            console.log("CHANGED_SHUTDOWN_STEP_CLIENT:", data)
        });

        this.socket.on("close", this.tryReconnect);
        this.socket.on("connection", (socket) => {
            this.socket.emit("login", {
                id: localStorage.getItem('userId')
            });
        });
        this.socket.connect();
    },

    beforeDestroy() {
        this.socket.disconnect();
        clearInterval(this.timer)
    },

    methods: {

        tryReconnect() {
            setTimeout(() => {
                this.socket.io.open((err) => {
                    if (err) {
                        this.tryReconnect();
                    }
                });
            }, 2000);
        },
    }
}